import { imageNames } from "@/src/constants/imageConstants.js";
import { permissionConstants } from "@/src/constants/permissionConstants.js";
import Profile from "@/src/views/profile/Profile.vue";
import Objects from "@/src/views/objects/Objects.vue";
import APIConfiguration from "@/src/views/settings/APIConfiguration.vue";
import UsersMain from "@/src/views/users/UsersMain.vue";
import Domains from "@/src/views/mailboxes/Domains.vue";
import Security from "@/src/views/security/Security.vue";
import Waterfall from "@/src/views/waterfall/Waterfall.vue";
import Workspace from "@/src/views/workspace/Workspace.vue";
import Mailboxes from "@/src/views/mailboxes/Mailboxes.vue";
import Pipelines from "@/src/views/pipelines/Pipelines.vue";
import BlockList from "@/src/views/block_lists/BlockList.vue";
import SSHKeys from "@/src/views/codebase/tokens/SSHKeys.vue";
import ExportsSection from "@/src/views/exports/ExportsSection.vue";
import Integrations from "@/src/views/integrations/Integrations.vue";
import UniboxSettings from "@/src/views/settings/UniboxSettings.vue";
import Availability from "@/src/views/availability/Availability.vue";
import VoiceMails from "@/src/views/calls/voicemails/Voicemails.vue";
import CustomEvents from "@/src/views/custom_events/CustomEvents.vue";
import BusinessDetail from "@/src/views/business/BusinessDetails.vue";
import CallRouting from "@/src/views/calls/call_logs/CallRouting.vue";
import TrackingDomain from "@/src/views/mailboxes/TrackingDomain.vue";
import ExternalDomains from "@/src/views/settings/ExternalDomains.vue";
import LinkedInAccount from "@/src/views/linkedin/LinkedInAccount.vue";
import PersonalMailbox from "@/src/views/mailboxes/PersonalMailbox.vue";
import EntityScoring from "@/src/views/entity_scoring/EntityScoring.vue";
import CampaignTemplate from "@/src/views/campaign/CampaignTemplate.vue";
import EmailTemplate from "@/src/views/email_template/EmailTemplate.vue";
import GithubAccounts from "@/src/views/code_reviewer/GithubAccounts.vue";
import PhoneNumbers from "@/src/views/calls/phone_number/PhoneNumbers.vue";
import SettingsAuditLogs from "@/src/views/settings/SettingsAuditLogs.vue";
import SupportSettings from "@/src/views/settings/SupportSettings.vue";
import HRSettings from "@/src/views/human_resource/settings/HRSettings.vue";
import DialerSettings from "@/src/views/calls/dialer_settings/DialerSettings.vue";
import CallDisposition from "@/src/components/call_components/CallDisposition.vue";
import MeetingDisposition from "@/src/components/meeting_components/MeetingDisposition.vue";
import CustomerSuccessSettings from "@/src/views/customer_success/CustomerSuccessSettings.vue";
import MeetingIntelligence from "@/src/views/meetings/conversational_intelligence/intelligence/MeetingIntelligence.vue";
import ConversationIntelligenceTemplates from "@/src/views/calls/conversation_intelligence/ConversationIntelligenceTemplates.vue";

export const settingsSidebarOptionKeys = {
  PERSONAL: "personal",
  PROFILE: "profile",
  AVAILABILITY: "availability",
  PERSONAL_MAILBOXES: "personal_mailboxes",
  LINKEDIN_ACCOUNT: "linkedin_account",
  WORKSPACE: "workspace",
  GENERAL: "general",
  BUSINESS: "business",
  SECURITY: "security",
  USERS: "users",
  INTEGRATIONS: "integrations",
  PIPELINES: "pipelines",
  MEETING_INTELLIGENCE: "meeting_intelligence",
  ENTITY_SCORING: "entity_scoring",
  UNIBOX: "unibox",
  EMAIL_TEMPLATES: "email_templates",
  CONVERSATION_INTELLIGENCE: "conversation_intelligence",
  VALUE_PROP_TEMPLATES: "value_prop_templates",
  OBJECTS: "objects",
  MAILBOXES: "mailboxes",
  VOICE_MAILS: "voice_mails",
  PHONE_NUMBERS: "phone_numbers",
  DIALER_SETTINGS: "dialer_settings",
  CALL_ROUTING: "call_routing",
  CALL_DISPOSITION: "call_disposition",
  MEETING_DISPOSITION: "meeting_disposition",
  BLOCKLISTS: "blocklists",
  EXPORTS: "exports",
  DOMAIN_TRACKING: "domain_tracking",
  DOMAINS: "domains",
  EXTERNAL_DOMAINS: "external_domains",
  API_KEYS: "api_keys",
  EMAIL_CAMPAIGN_SETTINGS: "email_campaign_settings",
  WHATSAPP: "whatsapp",
  WATERFALL: "waterfall",
  CUSTOMER_SUCCESS: "customer_success",
  AUDIT_TRAIL: "audit_trail",
  SUPPORT: "support",
  CUSTOM_EVENTS: "custom_events",
  PERSONAL_TOKENS: "personal_tokens",
  CODE_REVIEWER: "code_reviewer",
  SSH_KEYS: "ssh_keys",
  HR: "hr",
  ERROR_LOGGING: "error_logging",
};
import EmailCampaignSettings from "@/src/views/campaigns_in_engage/EmailCampaignSettings.vue";
import WhatsApp from "@/src/views/integrations/whatsapp/WhatsApp.vue";
import PersonalTokens from "@/src/views/codebase/tokens/PersonalTokens.vue";
import ErrorLoggingAlerts from "@/src/views/error-tracking/AlertSettingsPage.vue";

export const settingsSidebarOptions = [
  {
    key: settingsSidebarOptionKeys.PERSONAL,
    text: "PERSONAL",
    permission: permissionConstants.ALL,
    isHeader: true,
  },
  {
    key: settingsSidebarOptionKeys.PROFILE,
    text: "Profile",
    permission: permissionConstants.ALL,
    selected: imageNames.PROFILE_SELECTED,
    unselected: imageNames.PROFILE_UNSELECTED,
    icon_css: "size-4",
    component: Profile,
  },
  {
    key: settingsSidebarOptionKeys.AVAILABILITY,
    text: "Availability",
    permission: permissionConstants.ALL,
    selected: imageNames.AVAILABILITY_SELECTED,
    unselected: imageNames.AVAILABILITY_UNSELECTED,
    icon_css: "size-4",
    component: Availability,
  },
  {
    key: settingsSidebarOptionKeys.PERSONAL_MAILBOXES,
    text: "Personal Mailboxes",
    permission: permissionConstants.ALL,
    selected: imageNames.AT_THE_RATE_SELECTED,
    unselected: imageNames.AT_THE_RATE_GREY,
    icon_css: "size-4",
    component: PersonalMailbox,
  },
  {
    key: settingsSidebarOptionKeys.LINKEDIN_ACCOUNT,
    text: "Personal LinkedIn",
    permission: permissionConstants.ALL,
    selected: imageNames.LINKEDIN_SELECTED,
    unselected: imageNames.LINKEDIN_UNSELECTED,
    icon_css: "size-4",
    component: LinkedInAccount,
    feature_key: "linkedin_blocks",
  },
  {
    key: settingsSidebarOptionKeys.PERSONAL_TOKENS,
    text: "Personal Tokens",
    permission: permissionConstants.ALL,
    selected: imageNames.PERSONAL_TOKENS_SELECTED,
    unselected: imageNames.PERSONAL_TOKENS_UNSELECTED,
    icon_css: "size-4",
    component: PersonalTokens,
  },
  {
    key: settingsSidebarOptionKeys.SSH_KEYS,
    text: "SSH Keys",
    permission: permissionConstants.ALL,
    selected: imageNames.SSH_KEYS_SELECTED,
    unselected: imageNames.SSH_KEYS_UNSELECTED,
    icon_css: "size-4",
    component: SSHKeys,
  },
  {
    key: settingsSidebarOptionKeys.WORKSPACE,
    text: "WORKSPACE",
    isHeader: true,
  },
  {
    key: settingsSidebarOptionKeys.GENERAL,
    text: "General",
    permission: permissionConstants.ALL,
    selected: imageNames.GENERAL_SELECTED,
    unselected: imageNames.GENERAL_UNSELECTED,
    icon_css: "size-4",
    component: Workspace,
  },
  {
    key: settingsSidebarOptionKeys.BUSINESS,
    text: "Business Details",
    permission: permissionConstants.ALL,
    selected: imageNames.BUSINESS_DETAILS_SELECTED,
    unselected: imageNames.BUSINESS_DETAILS_UNSELECTED,
    icon_css: "size-4",
    component: BusinessDetail,
  },
  {
    key: settingsSidebarOptionKeys.SECURITY,
    text: "Security",
    permission: permissionConstants.ALL,
    selected: imageNames.ENCRYPTED_SELECTED,
    unselected: imageNames.ENCRYPTED_UNSELECTED,
    icon_css: "size-4",
    component: Security,
    feature_key: "saml",
  },
  {
    key: settingsSidebarOptionKeys.USERS,
    text: "Users & Teams",
    permission: permissionConstants.USERS,
    selected: imageNames.USERS_SELECTED,
    unselected: imageNames.USERS_UNSELECTED,
    icon_css: "size-4",
    component: UsersMain,
  },
  {
    key: settingsSidebarOptionKeys.INTEGRATIONS,
    text: "Integrations",
    permission: permissionConstants.INTEGRATIONS,
    selected: imageNames.INTEGRATIONS_SELECTED,
    unselected: imageNames.INTEGRATIONS_UNSELECTED,
    icon_css: "size-4",
    component: Integrations,
  },
  {
    key: settingsSidebarOptionKeys.WATERFALL,
    text: "Waterfall",
    permission: permissionConstants.WATERFALL,
    selected: imageNames.WATERFALL_SELECTED,
    unselected: imageNames.WATERFALL_UNSELECTED,
    icon_css: "size-4",
    component: Waterfall,
  },
  {
    key: settingsSidebarOptionKeys.PIPELINES,
    text: "Pipelines",
    permission: permissionConstants.DEAL_PIPELINE,
    selected: imageNames.PIPELINES_SELECTED,
    unselected: imageNames.PIPELINES_UNSELECTED,
    icon_css: "size-4",
    component: Pipelines,
  },
  {
    key: settingsSidebarOptionKeys.MEETING_INTELLIGENCE,
    text: "Meeting Intelligence",
    permission: permissionConstants.MEETINGS,
    selected: imageNames.MEETINGS_INTELLIGENCE_SELECTED,
    unselected: imageNames.MEETINGS_INTELLIGENCE_UNSELECTED,
    icon_css: "size-4",
    component: MeetingIntelligence,
    feature_key: "conversational_ai",
  },
  {
    key: settingsSidebarOptionKeys.MEETING_DISPOSITION,
    text: "Meeting Disposition",
    permission: permissionConstants.MEETINGS,
    selected: imageNames.MEETINGS_INTELLIGENCE_SELECTED,
    unselected: imageNames.MEETINGS_INTELLIGENCE_UNSELECTED,
    icon_css: "size-4",
    component: MeetingDisposition,
  },
  {
    key: settingsSidebarOptionKeys.ENTITY_SCORING,
    text: "Entity Scoring",
    permission: permissionConstants.ALL,
    selected: imageNames.ENTITY_SCORING_SELECTED,
    unselected: imageNames.ENTITY_SCORING_UNSELECTED,
    icon_css: "size-4",
    component: EntityScoring,
  },
  {
    key: settingsSidebarOptionKeys.UNIBOX,
    text: "Unibox",
    permission: permissionConstants.ALL,
    selected: imageNames.UNIBOX_SETTINGS_SELECTED,
    unselected: imageNames.UNIBOX_SETTINGS_UNSELECTED,
    icon_css: "size-4",
    component: UniboxSettings,
    feature_key: "unibox",
  },
  {
    key: settingsSidebarOptionKeys.HR,
    text: "HR",
    permission: permissionConstants.ALL,
    selected: imageNames.HR_SELECTED,
    unselected: imageNames.HR_UNSELECTED,
    icon_css: "size-4",
    component: HRSettings,
  },
  {
    key: settingsSidebarOptionKeys.EMAIL_TEMPLATES,
    text: "Email Templates",
    permission: permissionConstants.EMAIL_TEMPLATES,
    selected: imageNames.EMAIL_TEMPLATES_SELECTED,
    unselected: imageNames.EMAIL_TEMPLATES_UNSELECTED,
    icon_css: "size-4",
    component: EmailTemplate,
  },
  {
    key: settingsSidebarOptionKeys.CONVERSATION_INTELLIGENCE,
    text: "Conversation Intelligence",
    permission: permissionConstants.CALL_SETTINGS,
    selected: imageNames.CONVERSATIONAL_INTELLIGENCE_SELECTED,
    unselected: imageNames.CONVERSATIONAL_INTELLIGENCE_UNSELECTED,
    icon_css: "size-4",
    component: ConversationIntelligenceTemplates,
  },
  {
    key: settingsSidebarOptionKeys.CUSTOMER_SUCCESS,
    text: "Customer Success",
    permission: permissionConstants.ALL,
    selected: imageNames.CUSTOMER_SUCCESS_SETTINGS_SELECTED,
    unselected: imageNames.CUSTOMER_SUCCESS_SETTINGS_UNSELECTED,
    icon_css: "size-4",
    component: CustomerSuccessSettings,
    feature_key: "customer_success",
    app_code: "customer_success",
  },
  {
    key: settingsSidebarOptionKeys.VALUE_PROP_TEMPLATES,
    text: "Value Prop Templates",
    permission: permissionConstants.AI_SDR,
    selected: imageNames.CAMPAIGN_TEMPLATES_SELECTED,
    unselected: imageNames.CAMPAIGN_TEMPLATES_UNSELECTED,
    icon_css: "size-4",
    component: CampaignTemplate,
  },
  {
    key: settingsSidebarOptionKeys.OBJECTS,
    text: "Objects",
    permission: permissionConstants.OBJECTS,
    selected: imageNames.OBJECT_SELECTED,
    unselected: imageNames.OBJECT_UNSELECTED,
    icon_css: "size-4",
    component: Objects,
  },
  {
    key: settingsSidebarOptionKeys.MAILBOXES,
    text: "Shared Mailboxes",
    permission: permissionConstants.SHARED_EMAILS,
    selected: imageNames.MAILBOXES_SELECTED,
    unselected: imageNames.MAILBOXES_UNSELECTED,
    icon_css: "size-4",
    component: Mailboxes,
  },
  {
    key: settingsSidebarOptionKeys.EMAIL_CAMPAIGN_SETTINGS,
    text: "Email Campaign Settings",
    permission: permissionConstants.ALL,
    selected: imageNames.EMAIL_CAMPAIGN_SETTINGS_SELECTED,
    unselected: imageNames.EMAIL_CAMPAIGN_SETTINGS_UNSELECTED,
    icon_css: "size-4",
    component: EmailCampaignSettings,
  },
  {
    key: settingsSidebarOptionKeys.WHATSAPP,
    text: "WhatsApp",
    permission: permissionConstants.ALL,
    selected: imageNames.WHATSAPP_SELECTED,
    unselected: imageNames.WHATSAPP_GREY,
    icon_css: "size-4",
    component: WhatsApp,
    app_code: "whatsapp",
  },
  {
    key: settingsSidebarOptionKeys.SUPPORT,
    text: "Support",
    permission: permissionConstants.ALL,
    selected: imageNames.INBOUND_AGENT_SELECTED,
    unselected: imageNames.INBOUND_AGENT_UNSELECTED,
    icon_css: "size-4",
    component: SupportSettings,
  },
  {
    key: settingsSidebarOptionKeys.VOICE_MAILS,
    text: "Voicemails",
    permission: permissionConstants.CALL_SETTINGS,
    selected: imageNames.VOICEMAIL_SELECTED,
    unselected: imageNames.VOICEMAIL_UNSELECTED,
    icon_css: "size-4",
    component: VoiceMails,
  },
  {
    key: settingsSidebarOptionKeys.PHONE_NUMBERS,
    text: "Phone Numbers",
    permission: permissionConstants.CALL_SETTINGS,
    selected: imageNames.PHONE_NUMBERS_SELECTED,
    unselected: imageNames.PHONE_NUMBERS_UNSELECTED,
    icon_css: "size-4",
    component: PhoneNumbers,
  },
  {
    key: settingsSidebarOptionKeys.DIALER_SETTINGS,
    text: "Dialer Settings",
    permission: permissionConstants.CALL_SETTINGS,
    selected: imageNames.DIALER_SETTINGS_SELECTED,
    unselected: imageNames.DIALER_SETTINGS_UNSELECTED,
    icon_css: "size-4",
    component: DialerSettings,
  },
  {
    key: settingsSidebarOptionKeys.CALL_ROUTING,
    text: "Call Routing",
    permission: permissionConstants.CALL_SETTINGS,
    selected: imageNames.CALL_ROUTING_SELECTED,
    unselected: imageNames.CALL_ROUTING_UNSELECTED,
    icon_css: "size-4",
    component: CallRouting,
  },
  {
    key: settingsSidebarOptionKeys.CALL_DISPOSITION,
    text: "Call Disposition",
    permission: permissionConstants.CALL_SETTINGS,
    selected: imageNames.CALL_DISPOSITION_SELECTED,
    unselected: imageNames.CALL_DISPOSITION_UNSELECTED,
    icon_css: "size-4",
    component: CallDisposition,
  },
  {
    key: settingsSidebarOptionKeys.BLOCKLISTS,
    text: "Block List",
    permission: permissionConstants.INTEGRATIONS,
    selected: imageNames.BLOCK_LISTS_SELECTED,
    unselected: imageNames.BLOCK_LISTS_UNSELECTED,
    icon_css: "size-4",
    component: BlockList,
  },
  {
    key: settingsSidebarOptionKeys.EXPORTS,
    text: "Exports",
    permission: permissionConstants.EXPORT_ACCESS,
    selected: imageNames.EXPORT_SELECTED,
    unselected: imageNames.EXPORT_UNSELECTED,
    icon_css: "size-4",
    component: ExportsSection,
  },
  {
    key: settingsSidebarOptionKeys.DOMAIN_TRACKING,
    text: "Tracking Domains",
    permission: permissionConstants.INTEGRATIONS,
    selected: imageNames.TRACKING_DOMAIN_SELECTED,
    unselected: imageNames.TRACKING_DOMAIN_UNSELECTED,
    icon_css: "size-4",
    component: TrackingDomain,
  },
  {
    key: settingsSidebarOptionKeys.DOMAINS,
    text: "Domains",
    permission: permissionConstants.INTEGRATIONS,
    selected: imageNames.DOMAIN_SELECTED,
    unselected: imageNames.DOMAIN_UNSELECTED,
    icon_css: "size-4",
    component: Domains,
  },
  {
    key: settingsSidebarOptionKeys.EXTERNAL_DOMAINS,
    text: "External Domains",
    permission: permissionConstants.INTEGRATIONS,
    selected: imageNames.DOMAIN_SELECTED,
    unselected: imageNames.DOMAIN_UNSELECTED,
    icon_css: "size-4",
    component: ExternalDomains,
  },
  {
    key: settingsSidebarOptionKeys.AUDIT_TRAIL,
    text: "Audit Trail",
    permission: permissionConstants.ALL,
    selected: imageNames.ACTIVITY,
    unselected: imageNames.ACTIVITY,
    icon_css: "size-4",
    component: SettingsAuditLogs,
  },
  {
    key: settingsSidebarOptionKeys.API_KEYS,
    text: "API Keys",
    permission: permissionConstants.ALL,
    selected: imageNames.API_KEYS_SELECTED,
    unselected: imageNames.API_KEYS_UNSELECTED,
    icon_css: "size-4",
    component: APIConfiguration,
  },
  {
    key: settingsSidebarOptionKeys.CUSTOM_EVENTS,
    text: "Custom Events",
    permission: permissionConstants.ALL,
    selected: imageNames.CUSTOM_EVENTS_SELECTED,
    unselected: imageNames.CUSTOM_EVENTS_UNSELECTED,
    icon_css: "size-4",
    component: CustomEvents,
  },
  {
    key: settingsSidebarOptionKeys.CODE_REVIEWER,
    text: "Code Reviewer",
    permission: permissionConstants.ALL,
    selected: imageNames.CODE_REVIEWER_SELECTED,
    unselected: imageNames.CODE_REVIEWER_UNSELECTED,
    icon_css: "size-4",
    component: GithubAccounts,
  },
  {
    key: settingsSidebarOptionKeys.ERROR_LOGGING,
    text: "Error Logging",
    permission: permissionConstants.ALL,
    selected: imageNames.ERROR_LOGGING_SELECTED,
    unselected: imageNames.ERROR_LOGGING_UNSELECTED,
    icon_css: "size-4",
    component: ErrorLoggingAlerts,
  },
];

export const hiddenSettingsKeys = [
  settingsSidebarOptionKeys.MEETING_INTELLIGENCE,
  settingsSidebarOptionKeys.SECURITY,
  settingsSidebarOptionKeys.CUSTOMER_SUCCESS,
  settingsSidebarOptionKeys.LINKEDIN_ACCOUNT,
];

export const addPaddingInSettings = [
  settingsSidebarOptionKeys.PROFILE,
  settingsSidebarOptionKeys.BUSINESS,
];

export const noPaddingInSettings = [
  settingsSidebarOptionKeys.SECURITY,
  settingsSidebarOptionKeys.WHATSAPP,
];

export const leftPaddingOnlyInSettings = [settingsSidebarOptionKeys.WHATSAPP];

export const integrationStatus = {
  COMPLETE: "COMPLETE",
  PENDING: "PENDING",
};

export const integrationConnectType = {
  API_KEY: "API_KEY",
  WEBHOOK_URL: "WEBHOOK_URL",
  SALESFORCE: "SALESFORCE",
  HUBSPOT: "HUBSPOT",
  GOOGLE_CALENDAR: "GOOGLE_CALENDAR",
  FIREFLIES: "FIREFLIES",
  SENDSPARK: "SENDSPARK",
  READ_AI: "READ_AI",
  ZOOM: "ZOOM",
  WHATSAPP: "WHATSAPP",
  ZOHO: "ZOHO",
};

export const integrations = {
  OUTLOOK: "OUTLOOK",
  GMAIL: "GMAIL",
  APOLLO: "APOLLO",
  RB2B: "RB2B",
  LINKEDIN: "SHARED LINKEDIN",
  FIREFLIES: "FIREFLIES",
  SENDSPARK: "SENDSPARK",
  READ_AI: "READ_AI",
  SLACK: "SLACK",
  SALESFORCE: "SALESFORCE",
  ZOOM: "ZOOM",
  ZOHO: "ZOHO",
  WHATSAPP: "WHATSAPP",
};

export const integrationParents = {
  GMAIL: "Google",
  OUTLOOK: "Microsoft",
};

export const emailIntegrations = [integrations.OUTLOOK, integrations.GMAIL];
export const emailVendorIcons = {
  OUTLOOK: imageNames.OUTLOOK_LOGO,
  GMAIL: imageNames.GMAIL_LOGO,
  SMTP: imageNames.EMAIL_GREY,
  BULK_UPLOAD: imageNames.UPLOAD_GREY,
  ZOOM: imageNames.ZOOM_ICON,
};

export const emailSettingVendorIcons = {
  GMAIL: imageNames.EMAIL_GREY,
  OUTLOOK: imageNames.OUTLOOK_LOGO,
  SMTP: imageNames.EMAIL_GREY,
  BULK_UPLOAD: imageNames.UPLOAD_GREY,
  ZOOM: imageNames.ZOOM_ICON,
};

export const manageIntegrationsConnectType = [
  integrationConnectType.API_KEY,
  integrationConnectType.WEBHOOK_URL,
  integrationConnectType.SALESFORCE,
  integrationConnectType.HUBSPOT,
  integrationConnectType.GOOGLE_CALENDAR,
  integrationConnectType.FIREFLIES,
  integrationConnectType.SENDSPARK,
  integrationConnectType.READ_AI,
  integrationConnectType.ZOOM,
  integrationConnectType.ZOHO,
  integrationConnectType.WHATSAPP,
];

export const insertOptions = {
  EMAIL: "EMAIL",
  AI_SDR: "AI_SDR",
  LINKEDIN_INVITE: "LINKEDIN_INVITE",
  LINKEDIN_MESSAGE: "LINKEDIN_MESSAGE",
  LINKEDIN_INMAIL: "LINKEDIN_INMAIL",
  CONVERSATION_EMAIL: "CONVERSATION_EMAIL",
};

export const disconnect_integrations = [
  "SENDSPARK",
  "FIREFLIES",
  "READ_AI",
  "SLACK",
  "ZOOM",
];

export const integrationDemoInstructions = {
  [integrations.RB2B]: [
    {
      text: "Step 1: Copy this webhook URL from above and go to the RB2B platform. On RB2B dashboard, navigate to the integrations page (<a class='link_color no-underline' href='https://app.rb2b.com/integrations' target='_blank'>https://app.rb2b.com/integrations</a>) and click on the Webhook integration.",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/rb2b_setup_1.png",
    },
    {
      text: "Step 2: Add the webhook URL here and save the changes. Your RB2B SuperAGI integration is complete!",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/rb2b_setup_2.png",
    },
  ],
  [integrations.FIREFLIES]: [
    {
      text: "Step 1: Copy the webhook URL provided above. Go to the Fireflies platform, navigate to Developer Settings at (<a class='link_color no-underline' href='https://app.fireflies.ai/settings' target='_blank'>https://app.fireflies.ai/settings</a>), and add the webhook URL.",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/firefly_step_1.png",
    },
    {
      text: "Step 2: Generate the Secret Key by clicking the refresh icon.",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/firefly_step_2.png",
    },
    {
      text: "Step 3: Check the 'Transcription Completed' checkbox and save the webhook information ",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/firefly_step_3.png",
    },
    {
      text: "Step 4: Copy the Secret Key and API key from Fireflies",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/firefly_step_4.png",
    },
    {
      text: "Step 5: Paste the Secret Key and the API Key here, and save the changes. Your Fireflies SuperAGI integration is complete !",
      image: "",
    },
  ],
  [integrations.SENDSPARK]: [
    {
      text: "Step 1: In the SendSpark platform, Navigate to API Credentials Settings by visiting: <a class='link_color no-underline' href='https://sendspark.com/settings/api-credentials.' target='_blank'>https://sendspark.com/settings/api-credentials</a>.",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/sendspark_step_1.png",
    },
    {
      text: "Step 2: Click on the 'Create New Key' button to generate a New Key.",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/sendspark_step_2.png",
    },
    {
      text: "Step 3: Once the new key is created, you will see the Secret Key and API Key displayed on the screen.",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/sendspark_step_3.png",
    },
    {
      text: "Step 4: Copy both the Secret Key and API Key",
      image: "",
    },
    {
      text: "Step 5: Paste the copied Secret Key and API Key into the respective fields here.",
      image: "",
    },
    {
      text: "Step 6: In SendSpark, locate your Workspace ID by visiting <a class='link_color no-underline' href='https://sendspark.com/settings/api-credentials.' target='_blank'>https://sendspark.com/settings/api-credentials.</a>.",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/sendspark_step_6.png",
    },
    {
      text: "Step 7: Copy the Workspace ID and paste the it into the designated field here. Your SendSpark-SuperAGI integration is now complete!",
      image: "",
    },
  ],
  [integrations.READ_AI]: [
    {
      text: "Step 1: Copy the webhook URL provided above.",
      image: "",
    },
    {
      text: "Step 2: Go to the ReadAI platform and navigate to Webhook Settings by visiting: <a class='link_color no-underline' href='https://app.read.ai/analytics/integrations/user/workflow/webhooks' target='_blank'>https://app.read.ai/analytics/integrations/user/workflow/webhooks</a>.",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/read_ai_step_2.png",
    },
    {
      text: "Step 3: Click 'Add webhook' to add new a webhook.",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/read_ai_step_3.png",
    },
    {
      text: "Step 4: Paste the Copied webhook URL into the Webhook Settings field and save it. ",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/read_ai_step_4.png",
    },
    {
      text: "Step 5: Once the webhook is saved, test the integration by clicking on 'Send Test Request.'",
      image:
        "https://super-sales-public-files20240730144930944300000001.s3.amazonaws.com/instructions/read_ai_step_5.png",
    },
    {
      text: "Step 6: Your ReadAI-SuperAGI integration is now complete! ",
      image: "",
    },
  ],
};

export const billingTableHeader = [
  { label: "Title", key: "title", width: 4 },
  { label: "Type", key: "action_type", width: 2 },
  { label: "Created By", key: "created_by", width: 2, view: true },
  { label: "Done Date", key: "created_at", width: 2 },
  { label: "Actions Consumed", key: "credits_consumed", width: 2 },
];

export const campaignStatusOptions = {
  COMPLETE: "COMPLETE",
  ENDED: "ENDED",
  DRAFT: "DRAFT",
  IN_PROGRESS: "IN_PROGRESS",
};

export const progressBarColor = {
  "0%": "#7095EB",
  "100%": "#B343CB",
};
